angular.module('WTG.IDA',[]).factory('IDA',
 function($http,$httpParamSerializer,$rootScope,L,$interval) {
 var url = WTGCONFIG.ida_session_url, domain, db = WTGCONFIG.db;
 var session_timer=null;
 var loc=undefined;
 var languages = {"de":1,"it":2,"en":3,"es":4,"fr":5,"ru":14,"lv":22};
 function ida_request(cfg,cb) {
  if(!cfg.hasOwnProperty('withCredentials')) cfg.withCredentials=true;
  if(!cfg.hasOwnProperty('url')) cfg.url = url;
  if(cfg.params) {
   var p = cfg.params;
   if(domain!==undefined && !p.hasOwnProperty('dom')) p.dom = domain;
   if(db && !p.hasOwnProperty('db')) p.db = db;
  }
  $http(cfg).then(function(r) {
   cb(null,r);
  },function(/*r*/) {
   var e = new Error('error making request to ida');
   cb(e);
  });
 }

 var IDA = {
  set_url: function set_url(u) { url=u; return this },
  set_domain: function set_domain(d) { domain=d; return this },
  set_db: function set_db(d) { db=d; return this },

  check_session: function check_session(cb) {
   ida_request({method:"POST",params:{check:1}},function(e,r) {
    cb(e,e?undefined:(r.data!='0'));
   });
  },
  /** li: {sk:session key,un:user name} */
  login: function login(li,cb) {
   if(db==undefined || domain===undefined) return cb(new Error("Can't log into ida without db && domain information"));
   ida_request({method:"POST",params:{sk:li.sk,un:li.un}},function(e,r) {
     cb(e,e?undefined:(r.data=='1'));
   });
  },
  /* get individual IDA URLs.
   * TODO: DO THIS RIGHT */
  get_url: function(purpose,pp) {
   switch(purpose) {
    case 'user-tab':
     if(db===undefined) throw new Error("Don't have IDA database designation");
     return url.replace(/[^/]+$/,'')+'form.asp?action=Open&fid=1761&'+$httpParamSerializer(Object.assign({
      id:pp.acid,
      conn:db
     },loc&&{loc}));
    case 'create-account':
     if(db===undefined) throw new Error("Don't have IDA database designation");
     return url.replace(/[^/]+$/,'')+'form.asp?action=New&fid=1761&'+$httpParamSerializer(Object.assign({
      id: pp.selfid,
      conn: db
     },loc&&{loc}));
    case 'ticket-form':
     if(db===undefined) throw new Error("Don't have IDA database designation");
     return url.replace(/[^/]+$/,'')+'form.asp?action=Open&fid=2026&'+$httpParamSerializer(Object.assign({
      id: pp.convid,
      conn: db
     },loc&&{loc}));
    case 'administration':
     if(db===undefined) throw new Error("Don't have IDA database designation");
     return url.replace(/[^/]+$/,'')+'form.asp?action=Open&fid=2029&'+$httpParamSerializer(Object.assign({
      id: domain,
      conn: db
     },loc&&{loc}));
    case 'kpi':
     if(db===undefined) throw new Error("Don't have IDA database designation");
     return url.replace(/[^/]+$/,'')+'form.asp?action=Open&fid=2055&'+$httpParamSerializer(Object.assign({
      id: domain,
      conn: db
     },loc&&{loc}));
    default:
     throw new Error("Trying to find out URL for no known purpose?");
   }
  },
  set_language: function(code) {
   loc=languages[code];
  }
 };

 function enforce_ida_session(args) {
  IDA.check_session(function(e,r) {
   if(e) return L.error({err:e},"error checking ida session");
   if(r) return L.trace("IDA session available");
   if(!( args.acname && args.skey))
    return L.error("Session info for IDA is not available");
   IDA.login({sk:args.skey,un:args.acname},function(e,r) {
    if(e) return L.error({err:e},"error logging into IDA");
    if(!r) return L.error("failed to log into IDA");
    L.trace("IDA session created");
   });
  });
 }

 // {domain:}
 $rootScope.$on('wtg.interact.connect',function on_interact_connect(evt,args) {
  IDA.set_domain(args.domain);
 });

 $rootScope.$on('wtg.interact.login',function on_interact_login(evt,args) {
  if($rootScope.isHidden('ida')) return;
  enforce_ida_session(args);
  if(session_timer!=null) {
   $interval.cancel(session_timer);
  }
  session_timer = $interval(function(){
   //TODO: need to handle the case where the session check returns error
   enforce_ida_session(args);
  }, 600000);
 });
 return IDA;
});
